// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__sAIKm","message":"styles_message__G1Adl","details":"styles_details__m9_zQ","divider":"styles_divider__hXKbs"};